export enum EStrategyType {
    LaborLaw = 1,
    PublicHealthLaw = 2,
    FDX
}
